import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertService } from '../_services';
import { RestService } from './rest.service';


@Injectable({ providedIn: 'root' })
export class ChatService {
    onChatSelected: BehaviorSubject<any>;
    activeChatRoomsData: BehaviorSubject<any[]> = new BehaviorSubject([]);
    ChatRoom: BehaviorSubject<any> = new BehaviorSubject({});
    chatRoomId: string;
    contact: object;

    constructor(private restService: RestService, private alertService: AlertService,) {
        this.onChatSelected = new BehaviorSubject({
            chatId: '',
            dialog: [],
            contact: {}
        });
    }

    activeChatRooms(reqData: any) {
        return this.restService.post(reqData).pipe(map((res: any) => { this.activeChatRoomsData.next(res.Data); return res; }));
    }
    getChatRooms(reqData: any) {
        const req = {
            "activeChatRooms": reqData
        };
        return this.activeChatRooms(req);
    }
    getChatRoomUpdates(reqData: any) {
        return this.restService.post(reqData).pipe(map((res: any) => res));
    }
    getChatMessages(reqData: any, contact: any) {
        return this.restService.post(reqData).pipe(map((res: any) => {
            if (res.ResponseCode == 200) {
                this.chatRoomId = reqData[Object.keys(reqData)[0]]['chatRoomID'];
                this.contact = contact;
                const currentValue = this.onChatSelected.getValue();
                if (currentValue.chatId) {
                    currentValue.dialog = [];
                    this.onChatSelected.next(currentValue);
                }
                if (res.Data) {
                    this.setChatData(res.Data);
                } else {
                    this.setChatData([]);
                }
            }
            return res;
        }));
    }

    //abustamante
    openChatRoom(reqData: any) {
        //console.log('reqData:', reqData);
        return this.restService.post(reqData).pipe(map((res: any) => {
            console.log('res:', res);
            if (res.ResponseCode == 200) {
                this.setChatRoom(res.Data);
                return res;
            } else {
                if (res.Message === 'Invalid Deal.') {
                    this.alertService.error('The Deal associated with this chat does not exist.');
                    console.log('The Deal associated with this chat does not exist.');
                } else {
                    this.alertService.error(res.Message);
                }
            }
        }));
    }
    setChatData(chat: Array<object>) {
        const currentValue = this.onChatSelected.getValue();
        const updatedValue = {};
        updatedValue['chatId'] = this.chatRoomId;
        updatedValue['dialog'] = [...currentValue['dialog'], ...chat];
        updatedValue['contact'] = this.contact;
        this.onChatSelected.next(updatedValue);
    }
    setChatRoom(chatRoom: any) {
        this.ChatRoom.next(chatRoom);
    }
    getChatRoom() {
        return this.ChatRoom.asObservable();
    }
    getActiveChatRoomsData() {
        return this.activeChatRoomsData.asObservable();
    }
    readMail(reqData: any) {
        return this.restService.post(reqData).pipe(map((res: any) => res));
    }
}